import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-yukleme',
  templateUrl: 'yukleme.component.html',
  styleUrls: ['yukleme.component.css']
})
export class YuklemeComponent implements OnInit {

  deferredPrompt: any = null;

  constructor(private router: Router) {}

  // ================= INIT =================
  ngOnInit(): void {
    if (this.isAppInstalled()) {
      this.router.navigate(['/login']);
    }
  }

  // ================= PWA DETECTION =================
  isAppInstalled(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches
      || (window.navigator as any).standalone === true; // iOS Safari
  }

  // ================= INSTALL PROMPT =================
  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: any) {
    event.preventDefault();
    this.deferredPrompt = event;
  }

  // ================= INSTALL APP =================
  installApp() {
    if (!this.deferredPrompt) return;

    this.deferredPrompt.prompt();

    this.deferredPrompt.userChoice.then(() => {
      this.deferredPrompt = null;
    });
  }

  // ================= AFTER INSTALL =================
  @HostListener('window:appinstalled')
  onAppInstalled() {
    this.router.navigate(['/login']);
  }

  // ================= CONTINUE WEB =================
  continueWeb() {
    this.router.navigate(['/login']);
  }
}
